import { faPaperPlane, faRedo } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useSupport } from '../../hooks/useSupport'
import translations from '../../translations/en.json'
import { ErrorContent } from '../ErrorContent/ErrorContent'
import { LoadingButton } from '../LoadingButton/LoadingButton'
import { IErrorViewProps } from './ErrorBoundary'

export const DefaultErrorView = ({ error, errorInfo }: IErrorViewProps) => {
  const summary = error?.toString()
    ? `Issue Reported: "${error.toString()}"`
    : `Dashboard Application Issue Reported`
  const description =
    'There has been an error that has occured.%0D%0A%0D%0A%0D%0A' +
    `${error?.toString()}%0D%0A` +
    `${errorInfo?.componentStack}%0D%0A`
  const { hasSubmitted, isError, isSuccess, handleSubmit } = useSupport()
  const errorContent = {
    code: 500,
    message: (translations as any)['error.default_toast_message'],
    timestamp: new Date().toJSON(),
  }

  if (isSuccess && hasSubmitted) {
    return (
      <ErrorContent size="lg" error={errorContent} stack={error?.componentStack || error?.stack}>
        <div>Submitted issue to support.</div>
        <div>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => {
              window.location.reload()
            }}
          >
            <FontAwesomeIcon className="me-2" icon={faRedo} />
            Refresh page
          </button>
        </div>
      </ErrorContent>
    )
  }

  return (
    <ErrorContent size="lg" error={errorContent} stack={error?.componentStack || error?.stack}>
      <div>
        <LoadingButton
          type="button"
          className="btn btn-outline-primary"
          onClick={async () => {
            await handleSubmit({
              type: 'bug',
              summary,
              description,
              error_stack: errorInfo?.componentStack || error?.stack,
            })
          }}
        >
          <FontAwesomeIcon className="me-2" icon={faPaperPlane} />
          Send report {isError && 'again'}
        </LoadingButton>
      </div>
      <div>
        <button
          type="button"
          className="btn btn-link"
          onClick={() => {
            window.location.reload()
          }}
        >
          <FontAwesomeIcon className="me-2" icon={faRedo} />
          Refresh page
        </button>
      </div>
    </ErrorContent>
  )
}
